import React, { useEffect, useState } from "react";
import { TableContainer, TableHead, TableBody, TableRow, TableCell, Table } from '@mui/material'

function AssociatedLinkedWrappers ({ fetchUrl, headers, processData, emptyMessage }) {
  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    $.ajax({
      method: 'GET',
      url: fetchUrl,
      headers: {
        "Content-Type": "application/json",
      },
      success: (response) => {
        setRows(response.data);
        setTotalCount(response.count);
      },
      error: (err) => {
        console.log({ err });
      }
    });
  };

  return (
    <TableContainer>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead sx={styles.head}>
          <TableRow>
            {headers.map(header => (
              <TableCell key={header.key} sx={styles.cell}>{header.label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {totalCount === 0 ? (
            <TableRow>
              <TableCell colSpan={headers.length} sx={styles.emptyCell}>
                {emptyMessage}
              </TableCell>
            </TableRow>
          ) : (
            processData(rows, styles)
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const styles = {
  cell: {
    fontSize: 14,
    verticalAlign: 'initial',
  },
  rowGrey: {
    background: '#f1f1f1'
  },
  content: {
    cursor: 'pointer'
  },
  main: {
    marginTop: 40,
  },
  head: {
    backgroundColor: '#d6d6d6'
  },
  emptyCell: {
    fontSize: 14,
    textAlign: 'center',
  },
  list: {
    padding: 0,
  }
}

export default AssociatedLinkedWrappers;
